import { AbstractControl, ValidationErrors } from '@angular/forms';

const IBAN_LENGTHS: Record<string, number> = {
	AD: 24,
	AL: 28,
	AT: 20,
	BA: 20,
	BE: 16,
	BG: 22,
	BY: 28,
	CH: 21,
	CY: 28,
	CZ: 24,
	DE: 22,
	DK: 18,
	EE: 20,
	ES: 24,
	FI: 18,
	FO: 18,
	FR: 27,
	GB: 22,
	GI: 23,
	GR: 27,
	HR: 21,
	HU: 28,
	IE: 22,
	IS: 26,
	IT: 27,
	LI: 21,
	LT: 20,
	LU: 20,
	LV: 21,
	MC: 27,
	MD: 24,
	ME: 22,
	MK: 19,
	MT: 31,
	NL: 18,
	NO: 15,
	PL: 28,
	PT: 25,
	RO: 24,
	RS: 22,
	SE: 24,
	SI: 19,
	SK: 24,
	SM: 27,
	TR: 26,
	UA: 29,
	VA: 22,
	XK: 20,
};

const IBAN_COUNTRY_CURRENCY: Record<string, string> = {
	AD: 'EUR',
	AL: 'ALL',
	AT: 'EUR',
	BA: 'BAM',
	BE: 'EUR',
	BG: 'BGN',
	BY: 'BYN',
	CH: 'CHF',
	CY: 'EUR',
	CZ: 'CZK',
	DE: 'EUR',
	DK: 'DKK',
	EE: 'EUR',
	ES: 'EUR',
	FI: 'EUR',
	FO: 'DKK',
	FR: 'EUR',
	GB: 'GBP',
	GI: 'GIP',
	GR: 'EUR',
	HR: 'EUR',
	HU: 'HUF',
	IE: 'EUR',
	IS: 'ISK',
	IT: 'EUR',
	LI: 'CHF',
	LT: 'EUR',
	LU: 'EUR',
	LV: 'EUR',
	MC: 'EUR',
	MD: 'MDL',
	ME: 'EUR',
	MK: 'MKD',
	MT: 'EUR',
	NL: 'EUR',
	NO: 'NOK',
	PL: 'PLN',
	PT: 'EUR',
	RO: 'RON',
	RS: 'RSD',
	SE: 'SEK',
	SI: 'EUR',
	SK: 'EUR',
	SM: 'EUR',
	TR: 'TRY',
	UA: 'UAH',
	VA: 'EUR',
	XK: 'EUR',
};

function normalize(value: string): string {
	return value.replace(/\s+/g, '').toUpperCase();
}

export function ibanCurrencyCode(value: string | null | undefined): string | null {
	if (!value) {
		return null;
	}

	return IBAN_COUNTRY_CURRENCY[normalize(value).slice(0, 2)] ?? null;
}

function isMod97Valid(iban: string): boolean {
	const rearranged = iban.slice(4) + iban.slice(0, 4);

	let remainder = 0;
	for (const char of rearranged) {
		const code = char.charCodeAt(0);
		const value = code >= 65 && code <= 90 ? (code - 55).toString() : char;

		for (const digit of value) {
			remainder = (remainder * 10 + Number(digit)) % 97;
		}
	}

	return remainder === 1;
}

export function ibanValidator(control: AbstractControl): ValidationErrors | null {
	const rawValue = control.value as string | null | undefined;

	if (!rawValue) {
		return null;
	}

	const iban = normalize(rawValue);

	if (!/^[A-Z]{2}\d{2}[A-Z0-9]{9,30}$/.test(iban)) {
		return { iban: true };
	}

	const expectedLength = IBAN_LENGTHS[iban.slice(0, 2)];

	if (expectedLength === undefined || iban.length !== expectedLength) {
		return { iban: true };
	}

	return isMod97Valid(iban) ? null : { iban: true };
}
